
import { initComponentsNew, getParameterByName, callPinterestAPI, updateQueryString } from "@api/utils_2020";

const SearchSimple = {
   
    init: () => {
        var query = getParameterByName('q', window.location.href);
        pintrk('track', 'search', {
            event_id: eventID,
            search_query: query
        });
        SearchSimple.showTags(filterData);
        callPinterestAPI('search', { search_query: query });

        if (window.location.hash)
        {
            $(".pb23-search--header .list--wrapper").animate(
                {
                    scrollLeft: $(window.location.hash).offset().left - 80,
                },
                500
            );
        }

        $("button.all").on("click", function (evt) {
            evt.preventDefault(); // Impede comportamento padrão do botão, se necessário

            const $checkboxes = $(this).closest('div.wrapper').find('input[type="checkbox"]');
            $checkboxes.each(function () {
                const name = $(this).attr('name');
                const $checkbox = $('input[name="'+name+'"]');
                // Define o estado como não marcado de forma consistente
                $checkbox.prop('checked', false); // Atualiza a propriedade jQuery
                this.checked = false;             // Atualiza a propriedade nativa do DOM
                $checkbox.removeAttr('checked');  // Remove o atributo HTML (opcional)
                $checkbox.removeClass('checked');
            });

            const $radioboxes = $(this).closest('div.wrapper').find('input[type="radio"]');
            $radioboxes.each(function () {
                const name = $(this).attr('name');
                const $radiobox = $('input[name="'+name+'"]');
                // Define o estado como não marcado de forma consistente
                $radiobox.prop('checked', false); // Atualiza a propriedade jQuery
                this.checked = false;             // Atualiza a propriedade nativa do DOM
                $radiobox.removeAttr('checked');  // Remove o atributo HTML (opcional)
                $radiobox.removeClass('checked');
            });
            /*$(this).parent('div.wrapper').find('input[type="checkbox"]').each(function(idx, element)
            {
                $(element).prop('checked', false).removeAttr('checked');
                $(element)[0].checked = false;
            });*/
            
            $('.jsApplyFilter').prop('disabled', false);
            $('.jsApplyFilter').removeProp('disabled');
            if (!mobile && $(this).hasClass('mob'))
            {
               SearchSimple.refreshResults(1, false);
            }
            return true;
        });

            
        $("body").on("click", "input[type='radio']", function (evt) {
            const name = $(this).attr('name');
            const value = $(this).val();
            $('.jsClearFilters').trigger('click');

            const $radioboxes = $(this).closest('div.wrapper').find('input[type="radio"]');
            $radioboxes.each(function () {
                const name = $(this).attr('name');
                const $radiobox = $('input[name="'+name+'"]');
                // Define o estado como não marcado de forma consistente
                $radiobox.prop('checked', false); // Atualiza a propriedade jQuery
                this.checked = false;             // Atualiza a propriedade nativa do DOM
                $radiobox.removeAttr('checked');  // Remove o atributo HTML (opcional)
                $radiobox.removeClass('checked');
            });

            var elem = $('input[name="'+name+'"][value="'+value+'"]');
            elem.prop('checked', true); // Atualiza a propriedade jQuery
            elem[0].checked = true;             // Atualiza a propriedade nativa do DOM
            //elem.removeAttr('checked');  // Remove o atributo HTML (opcional)
            elem.addClass('checked');
            
            if ($(this).parents('.wrapper').find("input[type='radio']:checked").length == 0)
            {
                $(this).parents('.wrapper').find('button.all').trigger('click');
            }
            $('.jsApplyFilter').prop('disabled', false);
            $('.jsApplyFilter').removeProp('disabled');
            return true;
        });


        
        $("body").on("click", "input[type='checkbox']", function (evt) {
            const name = $(this).attr('name');
            if (!$(this).is(':checked'))
            {
                var elem = $('input[name="'+name+'"]');
                elem.prop('checked', false); // Atualiza a propriedade jQuery
                elem[0].checked = false;             // Atualiza a propriedade nativa do DOM
                elem.removeAttr('checked');  // Remove o atributo HTML (opcional)
                elem.removeClass('checked');
            }
            else
            {
                var elem = $('input[name="'+name+'"]');
                elem.prop('checked', true); // Atualiza a propriedade jQuery
                elem[0].checked = true;             // Atualiza a propriedade nativa do DOM
                //elem.removeAttr('checked');  // Remove o atributo HTML (opcional)
                elem.addClass('checked');
            }
            if ($(this).parents('.wrapper').find("input[type='checkbox']:checked").length == 0)
            {
                $(this).parents('.wrapper').find('button.all').trigger('click');
            }
            $('.jsApplyFilter').prop('disabled', false);
            $('.jsApplyFilter').removeProp('disabled');

            return true;
        });

        $("body").on("click", "input[name^='data[Year][1]']", function (evt) {
            if ($("input[name^='data[Year][1]']:checked").length != 0) {
                $('#Year button.pb23-input--fake.radio.all').removeClass('checked');
                $('.jsApplyFilter').prop('disabled', false);
            } else {
                $('#Year button.pb23-input--fake.radio.all').addClass('checked');
                $('.jsApplyFilter').prop('disabled', true);
            }
            if (!mobile && $(this).hasClass('mob'))
            {
               SearchSimple.refreshResults(1, false);
            }
            return true;
        });

        $("body").on("click", "input[name^='data[Type][1]']", function (evt) {
            if ($("input[name^='data[Type][1]']:checked").length != 0) {
                $('#Type button.pb23-input--fake.radio.all').removeClass('checked');
                $('.jsApplyFilter').prop('disabled', false);
            } else {
                $('#Type button.pb23-input--fake.radio.all').addClass('checked');
                $('.jsApplyFilter').prop('disabled', true);
            }
            if (!mobile && $(this).hasClass('mob'))
            {
               SearchSimple.refreshResults(1, false);
            }
            return true;
        });

        
        $("body").on("click", "input[name^='data[Class1][1]']", function (evt) {
            if ($("input[name^='data[Class1][1]']:checked").length != 0) {
                $('#Class1 button.pb23-input--fake.radio.all').removeClass('checked');
                $('.jsApplyFilter').prop('disabled', false);
            } else {
                $('#Class1 button.pb23-input--fake.radio.all').addClass('checked');
                $('.jsApplyFilter').prop('disabled', true);
            }
            if (!mobile && $(this).hasClass('mob'))
            {
                SearchSimple.refreshResults(1, false);
            }
            return true;
        });

        $("body").on("click", "input[name^='data[Class2][1]']", function (evt) {
            if ($("input[name^='data[Class2][1]']:checked").length != 0) {
                $('#Class2 button.pb23-input--fake.radio.all').removeClass('checked');
                $('.jsApplyFilter').prop('disabled', false);
            } else {
                $('#Class2 button.pb23-input--fake.radio.all').addClass('checked');
                $('.jsApplyFilter').prop('disabled', true);
            }
            if (!mobile && $(this).hasClass('mob'))
            {
                SearchSimple.refreshResults(1, false);
            }
            return true;
        });

        $("body").on("click", "input[name^='data[Class3][1]']", function (evt) {
            if ($("input[name^='data[Class3][1]']:checked").length != 0) {
                $('#Class3 button.pb23-input--fake.radio.all').removeClass('checked');
                $('.jsApplyFilter').prop('disabled', false);
            } else {
                $('#Class3 button.pb23-input--fake.radio.all').addClass('checked');
                $('.jsApplyFilter').prop('disabled', true);
            }
            if (!mobile && $(this).hasClass('mob'))
            {
                SearchSimple.refreshResults(1, false);
            }
            return true;
        });

        $("body").on("click", "input[name^='data[Line][1]']", function (evt) {
            if ($("input[name^='data[Line][1]']:checked").length != 0) {
                $('#Line button.pb23-input--fake.radio.all').removeClass('checked');
                $('.jsApplyFilter').prop('disabled', false);
            } else {
                $('#Line button.pb23-input--fake.radio.all').addClass('checked');
                $('.jsApplyFilter').prop('disabled', true);
            }
            if (!mobile && $(this).hasClass('mob'))
            {
               SearchSimple.refreshResults(1, false);
            }
            return true;
        });

        $("body").on("click", "input[name^='data[Color][1]']", function (evt) {
            if ($("input[name^='data[Color][1]']:checked").length != 0) {
                $('#Color button.pb23-input--fake.radio.all').removeClass('checked');
                $('.jsApplyFilter').prop('disabled', false);
            } else {
                $('#Color button.pb23-input--fake.radio.all').addClass('checked');
                $('.jsApplyFilter').prop('disabled', true);
            }
            if (!mobile && $(this).hasClass('mob'))
            {
                SearchSimple.refreshResults(1, false);
            }
            return true;
        });

        $("body").on("click", "input[name^='data[Format][1]']", function (evt) {
            if ($("input[name^='data[Format][1]']:checked").length != 0) {
                $('#Format button.pb23-input--fake.radio.all').removeClass('checked');
                $('.jsApplyFilter').prop('disabled', false);
            } else {
                $('#Format button.pb23-input--fake.radio.all').addClass('checked');
                $('.jsApplyFilter').prop('disabled', true);
            }
            if (!mobile && $(this).hasClass('mob'))
            {
                SearchSimple.refreshResults(1, false);
            }
            return true;
        });

        $("body").on("click", "input[name^='data[Edge][1]']", function (evt) {
            if ($("input[name^='data[Edge][1]']:checked").length != 0) {
                $('#Edge button.pb23-input--fake.radio.all').removeClass('checked');
                $('.jsApplyFilter').prop('disabled', false);
            } else {
                $('#Edge button.pb23-input--fake.radio.all').addClass('checked');
                $('.jsApplyFilter').prop('disabled', true);
            }
            if (!mobile && $(this).hasClass('mob'))
            {
                SearchSimple.refreshResults(1, false);
            }
            return true;
        });

        $("body").on("click", "input[name^='data[Material][1]']", function (evt) {
            if ($("input[name^='data[Material][1]']:checked").length != 0) {
                $('#Material button.pb23-input--fake.radio.all').removeClass('checked');
                $('.jsApplyFilter').prop('disabled', false);
            } else {
                $('#Material button.pb23-input--fake.radio.all').addClass('checked');
                $('.jsApplyFilter').prop('disabled', true);
            }
            if (!mobile && $(this).hasClass('mob'))
            {
                SearchSimple.refreshResults(1, false);
            }
            return true;
        });

        $("body").on("click", "input[name^='data[ProductFinishing][1]']", function (evt) {
            if ($("input[name^='data[ProductFinishing][1]']:checked").length != 0) {
                $('#ProductFinishing button.pb23-input--fake.radio.all').removeClass('checked');
                $('.jsApplyFilter').prop('disabled', false);
            } else {
                $('#ProductFinishing button.pb23-input--fake.radio.all').addClass('checked');
                $('.jsApplyFilter').prop('disabled', true);
            }
            if (!mobile && $(this).hasClass('mob'))
            {
                SearchSimple.refreshResults(1, false);
            }
            return true;
        });

        /*
        $("body").on("click", "input[name^='data[ProductClass4][1]']", function (evt) {
            $("input[name^='data[ProductClass4][1]']").removeClass('checked');
            $(this).addClass('checked');
            if (!mobile) {
                SearchSimple.refreshResults(1, false);
            } else {
                $('.jsApplyFilter').prop('disabled', false);
            }
            return false;
        });*/

        $("body").on("click", "input[name^='data[SalesChannel][1]']", function (evt) {
            evt.preventDefault();
            
            if ($(this).val() != "all") {
                $('.channelSelected').html($(this).data("name"));
                $('input[name^="data[SalesChannel][1][all]"]').prop('checked',false);
                $('input[name^="data[SalesChannel][1][all]"]').removeClass('checked');
                $('input[name^="data[SalesChannel][1][all]"]').removeAttr('checked');
                $('input[name^="data[SalesChannel][1]"]').prop('checked',false);
                $('input[name^="data[SalesChannel][1]"]').removeClass('checked');
                $('input[name^="data[SalesChannel][1]"]').removeAttr('checked');
            } else {
                $('.channelSelected').html("ver todos");
                $('input[name^="data[SalesChannel][1]"]:checked').prop('checked',false);
                $('input[name^="data[SalesChannel][1]"]:checked').removeClass('checked');
                $('input[name^="data[SalesChannel][1]"]:checked').removeAttr('checked');
            }
            $(this).prop('checked',true).addClass('checked');
            if (!mobile) {
                $('.visible').siblings('.pb23-submenu').hide("blind", 300);
                $('.visible').removeClass('visible');
                //Lines.refreshResults();
                SearchSimple.refreshResults();
            }
            return true;
        });

        $("body").on("click", "input[name='Order']", function (evt) {
            var order = $('input[name="Order"]:checked').val();
            $("input[name='Order']").removeClass('checked');
            if (!mobile) {
                $('.visible').siblings('.pb23-submenu').hide("blind", 300);
                $('.visible').removeClass('visible');
            } else {
                $('.jsApplyFilter').prop('disabled', false);
            }
            window.location.href = updateQueryString(window.location.href,'sort',order);
            
            return true;
        });


        $("body").on("click", "input[name=limit]", function (evt) {
            $("input[name=limit]").removeClass("checked");
            var limitSelected = $('input[name="limit"]:checked');
            limitSelected.addClass("checked");
            if ($("input[name=limit]:checked").length != 0) {
                $('.jsApplyFilter').prop('disabled', false);
            } else {
                $('.jsApplyFilter').prop('disabled', true);
            }

            $('.jsLimit').html(limitSelected.data("name"));
            if (!mobile && !tablet) {
                $('.visible').siblings('.pb23-submenu').hide("blind", 300);
                $('.visible').removeClass('visible');
                if (limitSelected.val()) {
                    var limitPerPage = limitSelected.val();
                    if (limitPerPage == 'all') {
                        limitPerPage = 100000;
                    }
                    var title = limitSelected.data('name');
                    dataLayer.push({
                        'event': "category_display", // Nome do evento.
                        'value': title // Valor do filtro que será aplicado.
                    });
                }
            }
            else
            {
                var limitPerPage = limitSelected.val();
            }
            window.location.href = updateQueryString(window.location.href,'limit',limitPerPage);
            return true;
        });

        $("body").on("click", ".jsApplyFilter", function (evt) {
            evt.preventDefault();
            $(".jsAuxmenuClose").trigger("click");
            $('.visible').siblings('.pb23-submenu').hide("blind", 300);
            $('.visible').removeClass('visible');
            return SearchSimple.refreshResults();
        });

        $("body").on("click", ".jsRemoveTag", function (evt) {
            var target = $(this).data('target');
            var type = $(this).data('type');
            $("input[name^='" + type + "'][value='" + target + "']").attr('checked', false);
            $("#" + target).remove();
            SearchSimple.refreshResults();
            return true;
        });

        $("body").on("click", ".jsClearTags", function (evt) {
            var dataTarget = $(this).data('target');

            $('input[name^="' + dataTarget + '"]:checked').prop('checked', false);
            SearchSimple.refreshResults();
        });

        $("body").on("click", ".jsClearFilters", function (evt) {
            $(".filters--tags ul").html("");
            $('input[name^="data[Class1][1]"]:checked').prop('checked', false);
            $('input[name^="data[Material][1]"]:checked').prop('checked', false);
            $('input[name^="data[ProductClass4][1]"]:checked').prop('checked', false);
            $('input[name^="data[Line][1]"]:checked').prop('checked', false);
            $('input[name^="data[SalesChannel][1]"]:checked').prop('checked', false);
            $('input[name^="data[Format][1]"]:checked').prop('checked', false);
            $('input[name^="data[ProductFinishing][1]"]:checked').prop('checked', false);
            $('input[name^="data[Color][1]"]:checked').prop('checked', false);
            $('input[name^="data[TechnicalApplication][1]"]:checked').prop('checked', false);
            $('input[name^="data[Edge][1]"]:checked').prop('checked', false);
            $('input[name^="data[Release][1]"]:checked').prop('checked', false);
            $('input[name="Order"]:checked').prop('checked', false);
            $('input[name="Order"][value="release"]').prop('checked', true);
            $(".tag").remove();

            SearchSimple.refreshResults();
        });
      
        $("body").on("click", ".pb23-navigation ul li a", function (evt) {
            evt.preventDefault();

            if ($(this).hasClass("active")) {
                return false;
            }

            let page = $(this).data("page");

            if ($(this).hasClass("previous-page")) {
                page = page - 1;
            } else if ($(this).hasClass("next-page")) {
                page = page + 1;
            }

            SearchSimple.refreshResults(page);

            return false;
        });
    },
    updateUrl: function (page) {
        var queryString = '?' + filter + '&' + $(".filterForm").serialize() + '&page=' + page; //  + '&sort=' + SearchSimple.sort + '&limit=' + limitPerPage + '&channel=' + channel;
        //queryString = queryString.replace(/(&)?data\[(Class1|Class4|ProductClass4|SalesChannel)\]\[1\]\[[0-9A-Za-z]*\]=1/g, '');
        //queryString = decodeURI(queryString).replace(/(&)?data\[(Class4|ProductClass4|SalesChannel)\]\[1\]\[[0-9A-Za-z]*\]=[0-9A-Za-z]*/g, '');
        queryString = queryString.replace(/&&/g, '&');
        const originalUrl = location.protocol + "//" + location.host + location.pathname;

        window.history.pushState({ content: originalUrl }, "", originalUrl + queryString);
    },
    refreshResults: (page, updateResults = true) => 
    {
        $('.filterForm input[name="page"]').val(page);
        if (updateResults)
        {
            $('.filterForm').submit();
        }
    },
    showTags: (filterData) =>
    {
        var data = filterData;
        $(".filters--tags ul").html("");
        var tags = [];

        $.each(data, function (key, value) {
            if (typeof value != 'undefined' && typeof value["1"] != 'undefined')
            {
                if (key === 'Class1' || key === 'Class2' || key === 'Class3' || key === 'Material' || key === 'Color' || key === 'ProductFinishing' || key === 'Line' || key === 'Format' || key === 'Edge' || key === 'TechnicalApplication') {
                    $.each(value["1"].childrens, function (index, item) {
                        if (item.checked) {
                            tags.push({
                                "filterType": key,
                                "target": "data["+key+"][1]",
                                "filterLabel": item.name,
                                "value": item.id
                            });
                        }
                    });
                }
            }
        });

        if (tags.length > 0) {
            UtilUi.loadTemplate("assets/components-new/pb23-filter--tag/pb23-filter--tag.tpl", function (dataOn, tpl) {
                const htmlContent = tpl.fetch({
                    items: tags
                });

                var htmlFull = htmlContent + "<li id='clearAll'><button class='pb23-btn action-link jsClearFilters'><span>Limpar tudo</span></button></li>";
                $(".filters--tags ul").html(htmlFull);
                initComponentsNew('pb23-filter--tag');
            });
        } else {
            $("#clearAll").remove();
        }
    }
};

export default () => {
    SearchSimple.init();
};


